import { ServiceHistoryRecord } from '../../shared/types';
import { OrderUtils } from '../../orders/utils/order.utils';

/** How many history rows each order has: one per payment, so a renewing membership has many. */
export function countServiceHistoryRowsByOrder(
  records: Pick<ServiceHistoryRecord, 'id'>[]
): Map<string, number> {
  const counts = new Map<string, number>();
  for (const record of records) {
    counts.set(record.id, (counts.get(record.id) ?? 0) + 1);
  }
  return counts;
}

/**
 * The price a Service History row shows, without the `$`.
 *
 * A membership renews as further payments on its signup order, and the order's price is frozen
 * at signup, so on an order with several payments each row shows what that payment collected.
 * An order paid once keeps the order price (the Way price for a Way-redeemed order).
 */
export function resolveServiceHistoryRowPrice(
  record: Pick<
    ServiceHistoryRecord,
    'final_price' | 'payment_amount' | 'way_pass_id' | 'way_price_paid'
  >,
  rowsOnOrder: number
): string {
  if (OrderUtils.isWayRedeemedOrder(record)) {
    return String(record.way_price_paid ?? record.final_price ?? '0.00');
  }
  const paid = record.payment_amount;
  if (rowsOnOrder > 1 && paid !== null && paid !== undefined && String(paid).trim() !== '') {
    return String(paid);
  }
  return record.final_price ?? '0.00';
}
